<template>

    <div :class="$attrs.class">
        <label
            v-if="label"
            class="form-label"
            :for="id">
                {{ label }}:
        </label>

        <popover v-if="info" class="float-right" placement="bottom-end">
            <template #default>
                <font-awesome-icon
                icon="fa-circle-info"
                class="text-gray-600 cursor-pointer" />
            </template>

            <template #dropdown>
                <div
                class="bg-primary text-white text-sm p-4 max-w-[250px] max-h-[300px] shadow-lg overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-blue-900 scrollbar-track-gray-200">
                    {{ info }}
                </div>
            </template>
        </popover>


        <div class="relative">
            <font-awesome-icon
                icon="fa-calendar"
                class="cursor-pointer z-10 absolute top-1/2 transform -translate-y-1/2 left-3"
                @click="() => this.$refs.dateinput.openMenu()" />

            <input
                ref="input"
                :id="id"
                type="text"
                v-bind="{ ...$attrs, class: null }"
                class="form-input pl-8"
                :class="{ error: error }"
                v-model="inputValue"
                autocomplete="off"
                v-mask="dateMask"
                @input="handleInput" />

        </div>

        <Datepicker
            ref="dateinput"
            menuClassName="dp-custom-date"
            v-model="inputValue"
            modelType="dd-MM-yyyy"
            weekStart="0"
            autoApply
            close-on-scroll
            locale="pt-BR"

            :clearable="false"
            :enableTimePicker="false"
            :class="{ error: error }">
                <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
                </template>
        </Datepicker>

        <div v-if="error" class="form-error">{{ error }}</div>
    </div>

</template>

<script>

import { v4 as uuid } from 'uuid'
import { mask } from 'vue-the-mask'

import Datepicker from '@vuepic/vue-datepicker'

import Popover from '@/Shared/Components/Popover'

import '@vuepic/vue-datepicker/dist/main.css'


export default {
    inheritAttrs: false,

    emits: ['update:modelValue', 'inputDate'],

    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },

        type: {
            type: String,
            default: 'text',
        },

        info: String,
        error: String,
        label: String,
        modelValue: String,
    },

    components: {
        Datepicker,
        Popover,
    },

    directives: {
        mask,
    },

    data() {
        return {
            inputValue: '',
            dateMask: '##/##/####',
        }
    },


    created() {

        if (this.$props.modelValue) {
            const [ year, month, day ] = this.$props.modelValue.split('-')

            this.inputValue = `${day}-${month}-${year}`
        }

    },

    methods: {
        formatDate(value) {
            const [ day, month, year ] = value.split('/')

            const dayFormated = (day ?? '0').padStart(2, '0')
            const monthFormated = (month ?? '0').padStart(2, '0')
            const yearFormated = (year ?? '0').padStart(4, '0')

            return `${yearFormated}-${monthFormated}-${dayFormated}`
        },

        handleInput() {
            const formatedDateToEmit = this.formatDate(this.inputValue)
            this.$emit('inputDate', formatedDateToEmit)
        }
    },


    watch: {
        inputValue(nextValue, oldValue) {
            const formatedDateToEmit = this.formatDate(nextValue)
            this.$emit('update:modelValue', formatedDateToEmit)
        }
    },

}

</script>


<style>
.dp-custom-date .dp__overlay_cell_active,
.dp-custom-date .dp__active_date {
  background-color: var(--color-primary);
}
</style>
